import React, { Component } from 'react';
import { message, Button, Tabs, Input, Icon } from 'antd';
import API_URL from '../../common/url';
import SearchGroup from '../common/searchGroup/SearchGroup';
import ExecuteSider from './ExecuteSider';
import store from '../../store';
import CrfTable from './CrfTable';
import $ from '../../common/AjaxRequest';
import SiteSearchInput from "./SiteAutoSearch";
import { clearSearch } from '../../actions/executeActions';
import ExportUtil from '../../common/ExportUtil';
import ViolationTree from './ViolationTree';
import deepClone from '../shared/deepClone';
import './style/list.less';
import { queryInvestigationStage, canEditByInvStatus } from '../common/queryInvestigationStage';

const { TabPane } = Tabs;
const DefaultState = {
    sortParams: {},
    searchParams: {},
    pagination: {
        pageSize: 10,
        current: 1,
    },
    loading: false,
    controllers: [],
    searchArray: [],
    tableColumns: [],
    tableDatas: [],
    siteArray: [],
    addable: false,
    panes: [],
    activeKey: '',
    isRelative: true,
    renderSearch: true,
    renderSite: true,
    isFilterProcess:0
};
// const Title = {
//     Type_Pre_Filter: '预筛记录',
//     Type_Filter: '筛选记录',
//     Type_Visit: '访视记录',
//     Type_Drop: '退出记录',
//     Type_Violation: '方案违背',
//     Type_SAE: 'SAE记录',
//     Type_Drug_Overtemperature: '药物超温',
//     Type_Drug_Breakage: '药物破损',
//     Type_Instrument_Certificate: '仪器设备校准证书',
//     Type_Drug_Blindness: '药物破盲',
//     Type_Drug_Inventory: '药物库存量',
// };

class Crf extends Component {
    constructor(props) {
        super(props);
        const { match: { params: { typeName, patientId } } } = this.props;
        this.queryInvestigationStage = queryInvestigationStage.bind(this);
        this.canEditByInvStatus = canEditByInvStatus.bind(this);
        this.published = false;
        this.state = {
            typeName,
            patientUserId: patientId || '',
            ...deepClone(DefaultState)
        };
    }

    componentDidMount() {
        this.queryPlan();
        const { invId } = sessionStorage;
        this.queryInvestigationStage(invId);
        this.queryInvStatus();
    }

    componentWillReceiveProps(nextProps) {
        const { typeName, patientId } = nextProps.match.params;
        store.dispatch(clearSearch());
        this.setState({
            typeName,
            patientUserId: patientId || '',
            ...deepClone(DefaultState)
        }, () => {
            this.queryPlan();
            this.queryInvStatus();
        });
    }

    componentWillUnmount() {
        sessionStorage.removeItem('againstType');
    }

    handleTabChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.search();
        });
    }

    queryPlan = () => {
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryVisitGrouping,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data, currentPublishStatus } = res;
                const [{ visitGroupingId } = {}] = data || [];
                const activeKey = visitGroupingId ? String(visitGroupingId) : undefined;
                this.published = currentPublishStatus === 'PUBLISHED';
                this.setState({
                    activeKey,
                    loading: false,
                    panes: data || [],
                }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    queryInvStatus = () => {
        const { invId } = sessionStorage;
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryInvStatus,
            data: {
                investigationId: invId,
                publishStatus: this.published ? 'UNPUBLISHED' : 'PUBLISHED',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({  isFilterProcess: res.isFilterProcess });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    loadData = (isAdd) => {
        let { pagination, patientUserId, activeKey, isRelative, typeName, sortParams, searchParams } = this.state;
        const { current } = pagination;

        this.setState({ loading: true });
        const options = {
            url: API_URL.execute.list,
            data: {
                typeName: typeName == 'Type_Violation' ? (isRelative ? typeName : 'Type_Nopatient_Violation') : typeName,
                offset: current,
                limit: 10,
                ...sortParams,
                ...searchParams,
                ...this.getParams(),
                patientUserId,
                visitGroupingId: activeKey,
            },
            dataType: 'json',
            doneResult: res => {
                const { pagination } = this.state;
                const { addable, data} = res;
                const { datas = [], totalCount, tree = {} } = data || {};
                const { controllers = [], tableColumns = [], searchColumns } = tree.data || {};
                const searchArray = [];
                const isVisit = typeName === 'Type_Visit';
                ((isVisit ? searchColumns : tableColumns) || []).forEach((value, index) => {
                    if (value['projectDefineSearchFlag'] == 1) {
                        if (value['moduleDefineName'] == '方案违背分类' && !isVisit) {
                            this.setState({ againstModuleDefineCode: value.moduleDefineCode });
                        }
                        searchArray.push(value);
                    }
                });
                if (tableColumns.length > 0) {
                    tableColumns.push({
                        moduleDefineCode: 'op',
                        moduleDefineName: '操作',
                        criteriaDataType: 'TEXT',
                        isShow: 1,
                    });
                }
                if (datas.length > 10) {
                    pagination.pageSize = datas.length;
                    pagination.total = Math.ceil(totalCount / 10) * (datas.length - 10) + totalCount;
                } else {
                    pagination.pageSize = 10;
                    pagination.total = totalCount;
                }

                this.setState({
                    controllers,
                    searchArray,
                    tableColumns,
                    tableDatas: datas,
                    loading: false,
                    pagination,
                    siteArray: [1],
                    addable: addable != 0,
                    patientUserId: '',
                }, () => {
                    if (isAdd == "add") {
                        this.handleAdd();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getParams = () => {
        const { searchParams } = store.getState().executeState;
        const { isRelative, searchParams: ssearchParams, againstType, againstModuleDefineCode } = this.state;
        const { againstTypeId = '' } = againstType || {};
        const { investigationSiteId } = ssearchParams;
        const params = {};
        for (let key in searchParams) {
            const path = `conditions[${key}].listConditions[0]`;
            const { projectDefineWebType: type, searchValue, moduleDefineName } = searchParams[key];
            if (searchValue) {
                if (type === 'INPUT') {
                    params[`${path}.conditions[0].oper`] = 'LIKE';
                    params[`${path}.conditions[0].value`] = searchValue;
                } else if (type === 'SELECT' || type === 'RADIO') {
                    params[`${path}.conditions[0].oper`] = 'EQ';
                    params[`${path}.conditions[0].value`] = searchValue;
                } else if (type === 'DATETIMEPICKER' && Array.isArray(searchValue)) {
                    params[`${path}.conditions[0].oper`] = 'GE';
                    params[`${path}.conditions[0].value`] = searchValue[0];
                    params[`${path}.oper`] = 'AND';
                    params[`${path}.conditions[1].oper`] = 'LE';
                    params[`${path}.conditions[1].value`] = searchValue[1];
                }
            }
        }
        if (againstTypeId && isRelative) {
            params[`conditions[${againstModuleDefineCode}].listConditions[0].conditions[0].oper`] = 'EQ';
            params[`conditions[${againstModuleDefineCode}].listConditions[0].conditions[0].value`] = againstTypeId;
        }
        if (investigationSiteId) {
            params.siteId = investigationSiteId;
        }
        return params;
    }

    handleTableChange = (params) => {
        this.setState({ ...params }, () => {
            this.loadData();
        });
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    reset = () => {
        store.dispatch(clearSearch());
        this.setState({
            againstType: {},
            sortParams: {},
            searchParams: {},
            renderSite: false,
        }, () => {
            this.loadData();
            this.setState({ renderSite: true });
        });
    }

    export = () => {
        const { sortParams, searchParams, activeKey, isRelative, typeName } = this.state;
        const { sort, direction } = sortParams;
        const { investigationSiteId } = searchParams;
        const params = this.getParams();
        params.typeName = (typeName == 'Type_Violation' && !isRelative) ? 'Type_Nopatient_Violation' : typeName;
        params.visitGroupingId = activeKey;
        if (investigationSiteId) {
            params.siteId = investigationSiteId;
        }
        if (sort) {
            params.sort = sort;
            params.direction = direction;
        }
        ExportUtil.export(params, null, API_URL.export.exportTypeVisit);
    }

    handleSelectSite = ({ value, text }) => {
        const { searchParams } = this.state;
        searchParams.investigationSiteId = value;
        searchParams.investigationSiteCode = text;
        this.setState({ searchParams });
    }

    handleSiteChange = value => {
        if ((value && value.key == "") || !value) {
            const { searchParams } = this.state;
            searchParams.investigationSiteId = undefined;
            searchParams.investigationSiteCode = undefined;
            this.setState({ searchParams });
        }
    }

    handleAdd = () => {
        const { pagination} = this.state;
        const { current } = pagination;
        if (this.crfTableRef.state.loading) {
            message.warning('数据正在加载中，请稍后操作！');
            return;
        }
        if (!this.published) {
            message.warning('本项目未发布访视周期计划，不可添加记录；');
            return;
        }
        if (current == 1) {
            this.setState(prevState => ({ addable: !prevState.addable }), () => {
                this.crfTableRef.handleAdd();
            });
        } else {
            pagination.current = 1;
            this.setState({ pagination }, () => {
                this.loadData("add");
            });
        }
    }

    clearSiteSelect = () => {
        this.siteSearchInput.clearValue();
    }

    getContent = (pane) => {
        const { loading, typeName, tableColumns, tableDatas, controllers, pagination, sortParams, activeKey, panes, isRelative } = this.state;
        const { visitGroupingId } = pane;
        if (visitGroupingId == activeKey) {
            const { blindType, relatedSiteId } = sessionStorage;
            const isUnBlind = blindType === 'NOTBLIND';
            const relateCenter = !!relatedSiteId;
            let controller
            if (isUnBlind && !relateCenter) {
                controller = controllers.filter(i => {
                    if (
                        (i.controllerName === '患者状态' && i.controlledName === '完成试验时间') ||
                        (i.controllerName === '患者状态' && i.controlledName === '是否最后一个病例完成试验')
                    ) {
                        return true;
                    }
                });
            } else {
                controller = controllers;
            }
            return (
                <CrfTable
                    controllers={controller}
                    tableColumns={tableColumns}
                    tableDatas={tableDatas}
                    typeName={typeName}
                    ref={el => this.crfTableRef = el}
                    loading={loading}
                    loadData={this.loadData}
                    pagination={pagination}
                    sortParams={sortParams}
                    visitGroup={panes}
                    currentGroup={pane}
                    changeTabs={this.handleTabChange}
                    isRelative={isRelative}
                    isUnBlind={isUnBlind}
                    relateCenter={!!relatedSiteId}
                    canEditByInvStatus={this.canEditByInvStatus}
                    handleTableChange={this.handleTableChange}
                />
            );
        } else {
            return null;
        }
    }

    showViolationTree = () => {
        this.violationRef.show();
    }

    saveViolateData = params => {
        this.setState({ againstType: { ...params } });
    }

    clearAgainstType = () => {
        this.setState({ againstType: {} });
    }

    handleBtnClick = () => {
        this.setState(prevState => ({
            isRelative: !prevState.isRelative,
            sortParams: {},
            againstType: {},
            searchParams: {},
            renderSite: false,
            renderSearch: false,
        }), () => {
            this.loadData();
            this.setState({
                renderSite: true,
                renderSearch: true,
            });
        })
    }

    render() {
        const { loading, typeName, searchArray, siteArray, addable, activeKey, panes, isRelative, againstType, renderSearch, renderSite, isFilterProcess } = this.state;
        const { againstTypeName = '' } = againstType || {};
        const { siteId, curRole } = sessionStorage;
        const addAuth = curRole === 'CRC' && addable && !(typeName === 'Type_Filter' && isFilterProcess == 0);
        return (
            <div className="content">
                <ExecuteSider selectKey={typeName} />
                <div className="main execute-crf">
                    {
                        typeName === 'Type_Violation' &&
                        <div className="tab_flex" style={{ marginBottom: 20 }}>
                            <a className={isRelative && "curr"} onClick={this.handleBtnClick} >与患者有关的违背</a>
                            <a className={!isRelative && "curr"} onClick={this.handleBtnClick} >与患者无关的违背</a>
                        </div>
                    }
                    <div className="search-bar" style={{ marginBottom: 16 }}>
                        {
                            renderSearch &&
                            searchArray.map((item, i) => {
                                if ((item.moduleDefineName != '方案违背分类') || (item.moduleDefineName == '方案违背分类' && !isRelative)) {
                                    return <SearchGroup key={item.moduleDefineId} searchItem={item} />
                                }
                            })
                        }
                        {
                            typeName === 'Type_Violation' && isRelative && (searchArray.length > 0) &&
                            <div className="search-item">
                                <label htmlFor="" className="ui-label">方案违背分类</label>
                                <div className="against-type">
                                    <Input value={againstTypeName} placeholder='请选择' onClick={this.showViolationTree} />
                                    {
                                        againstTypeName &&
                                        <Icon
                                            className="close"
                                            type="close-circle"
                                            onClick={this.clearAgainstType}
                                        />
                                    }
                                </div>
                            </div>
                        }
                        {
                            siteArray.map((v, i) =>
                                siteId == 0 && renderSite &&
                                <div className="search-item" key={i}>
                                    <label htmlFor="" className="ui-label">中心名称\中心编号</label>
                                    <SiteSearchInput
                                        allowClear={true}
                                        selectKey={typeName}
                                        style={{ width: 160 }}
                                        handleSelectSite={this.handleSelectSite}
                                        watchValue={this.handleSiteChange}
                                        ref={el => this.siteSearchInput = el}
                                    />
                                </div>
                            )
                        }
                        <div className="search-item">
                            <Button type="primary" style={{ marginRight: 0 }} disabled={loading} onClick={this.search}>搜索</Button>
                        </div>
                        <div className="search-item">
                            <Button type="primary" style={{ marginRight: 0 }} onClick={this.reset}>重置</Button>
                        </div>
                        <div className="search-item">
                            <Button type="primary" style={{ marginRight: 0 }} onClick={this.export}>导出</Button>
                        </div>
                        {
                            addAuth &&
                            <div className="search-item">
                                <Button type="primary" style={{ marginRight: 0 }} onClick={() => this.canEditByInvStatus(this.handleAdd)}>添加</Button>
                            </div>
                        }
                        {
                            (typeName === 'Type_Filter' || typeName === 'Type_Visit') &&
                            <div className="search-item" style={{ marginLeft: 'auto' }}>
                                <Button type="primary" style={{ marginRight: 0 }} onClick={() => this.crfTableRef.configColumn()}>自定义列</Button>
                            </div>
                        }
                    </div>
                    {
                        (curRole === 'CRC' && isFilterProcess == 0 && typeName === 'Type_Filter' && !addAuth ) &&
                        <div style={{color:'red', marginBottom:10}}> 本项目不包含筛选流程，不可添加筛选记录，请直接在访视记录页进行添加”；</div>
                    }
                    {
                        (typeName === 'Type_Visit' && panes.length > 1)  ?
                            <Tabs
                                onChange={this.handleTabChange}
                                activeKey={activeKey}
                                type="card"
                            > 
                            {
                                panes.map(pane => (
                                    <TabPane
                                        forceRender={true}
                                        key={pane.visitGroupingId}
                                        tab={<div className="execute-crf-tab">{pane.visitGroupingName}</div>}
                                    >
                                        {this.getContent(pane)}
                                    </TabPane>
                                ))
                                }
                            </Tabs>
                        :
                            this.getContent(panes.length ? panes[0] : {})
                    }
                    <ViolationTree ref={el => this.violationRef = el} saveViolateData={this.saveViolateData} />
                </div>
            </div>
        );
    }
}

export default Crf;


// WEBPACK FOOTER //
// ./src/components/execute/Crf.js